import type { Template } from "@/types";

export const SQ_04_H4_V0: Template[] = [
    {
        id: "sq-04-h4v0-01",
        name: "SQ 01 - H4V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h4_v0_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 72, y: 72, width: 1006, height: 575, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1086, y: 72, width: 280, height: 187, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1086, y: 267, width: 280, height: 185, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1086, y: 460, width: 280, height: 187, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h4v0-02",
        name: "SQ 02 - H4V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h4_v0_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 295, y: 77, width: 421, height: 279, rotation: 0, imageRotation: 0 },
            { id: "2", x: 295, y: 364, width: 421, height: 279, rotation: 0, imageRotation: 0 },
            { id: "3", x: 724, y: 77, width: 421, height: 279, rotation: 0, imageRotation: 0 },
            { id: "4", x: 724, y: 364, width: 421, height: 279, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h4v0-03",
        name: "SQ 03 - H4V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h4_v0_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 151, y: 77, width: 421, height: 279, rotation: 0, imageRotation: 0 },
            { id: "2", x: 151, y: 364, width: 421, height: 279, rotation: 0, imageRotation: 0 },
            { id: "3", x: 868, y: 77, width: 421, height: 279, rotation: 0, imageRotation: 0 },
            { id: "4", x: 868, y: 364, width: 421, height: 279, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h4v0-04",
        name: "SQ 04 - H4V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h4_v0_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 45, y: 256, width: 311, height: 208, rotation: 0, imageRotation: 0 },
            { id: "2", x: 364, y: 256, width: 311, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 766, y: 256, width: 311, height: 208, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1085, y: 256, width: 311, height: 208, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h4v0-05",
        name: "SQ 05 - H4V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h4-v0_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 242, width: 347, height: 235, rotation: 0, imageRotation: 0 },
            { id: "2", x: 355, y: 242, width: 361, height: 235, rotation: 0, imageRotation: 0 },
            { id: "3", x: 724, y: 242, width: 360, height: 235, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1092, y: 242, width: 347, height: 235, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h4v0-06",
        name: "SQ 06 - H4V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h4_v0_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 126, y: 46, width: 466, height: 310, rotation: 0, imageRotation: 0 },
            { id: "2", x: 126, y: 364, width: 466, height: 310, rotation: 0, imageRotation: 0 },
            { id: "3", x: 848, y: 46, width: 466, height: 310, rotation: 0, imageRotation: 0 },
            { id: "4", x: 848, y: 364, width: 466, height: 310, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h4v0-07",
        name: "SQ 07 - H4V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h4_v0_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 48, y: 46, width: 466, height: 310, rotation: 0, imageRotation: 0 },
            { id: "2", x: 48, y: 364, width: 466, height: 310, rotation: 0, imageRotation: 0 },
            { id: "3", x: 926, y: 46, width: 466, height: 310, rotation: 0, imageRotation: 0 },
            { id: "4", x: 926, y: 364, width: 466, height: 310, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h4v0-08",
        name: "SQ 08 - H4V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h4_v0_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 208, y: 47, width: 305, height: 203, rotation: 0, imageRotation: 0 },
            { id: "2", x: 208, y: 258, width: 305, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 208, y: 469, width: 305, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 783, y: 165, width: 585, height: 389, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h4v0-09",
        name: "SQ 09 - H4V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h4_v0_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 50, y: 47, width: 305, height: 203, rotation: 0, imageRotation: 0 },
            { id: "2", x: 50, y: 258, width: 305, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 50, y: 469, width: 305, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 772, y: 156, width: 611, height: 408, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h4v0-10",
        name: "SQ 10 - H4V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h4_v0_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 144, y: 74, width: 279, height: 186, rotation: 0, imageRotation: 0 },
            { id: "2", x: 144, y: 268, width: 279, height: 184, rotation: 0, imageRotation: 0 },
            { id: "3", x: 144, y: 460, width: 279, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 431, y: 74, width: 865, height: 572, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-04-h4v0-11",
        name: "SQ 11 - H4V0",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-04-h4_v0_11.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 46, y: 47, width: 627, height: 412, rotation: 0, imageRotation: 0 },
            { id: "2", x: 46, y: 467, width: 309, height: 207, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 467, width: 310, height: 207, rotation: 0, imageRotation: 0 },
            { id: "4", x: 763, y: 154, width: 627, height: 411, rotation: 0, imageRotation: 0 }
        ],
    },

    

];

